import { useEffect, useState } from "react";
import { isMobileIOS } from "../utils/user_agent";
import "../../stylesheets/chat_page.css";

const APP_STORE_URL = "https://apps.apple.com/us/app/incite-ai/id6476565263";
const DISMISS_KEY = "downloadAppBannerDismissed";

const DownloadAppBanner = () => {
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.navigator.standalone ||
      window.matchMedia("(display-mode: standalone)").matches;

    if (!isMobileIOS() || isStandalone) return;
    if (sessionStorage.getItem(DISMISS_KEY)) return;

    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setClosing(true);
    setTimeout(() => setVisible(false), 300);
  };

  if (!visible) return null;

  return (
    <div
      className={`download-app-banner${
        closing ? " download-app-banner--closing" : ""
      }`}
    >
      <button
        className="download-app-banner__close"
        aria-label="Dismiss"
        onClick={dismiss}
      >
        ×
      </button>
      <img
        className="download-app-banner__icon"
        src="/apple-touch-icon.png"
        alt="Incite AI"
      />
      <div className="download-app-banner__text">
        <span className="download-app-banner__title">Incite AI</span>
        <span className="download-app-banner__subtitle">
          Get the full experience in the app
        </span>
      </div>
      <a
        className="download-app-banner__cta"
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={dismiss}
      >
        Get
      </a>
    </div>
  );
};

export default DownloadAppBanner;
